import TwoCol from './row_two_col'

export default {
  row_two_col: TwoCol,
}
